import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../public/icons/Brush.png'
import _imports_1 from './../../public/icons/Eraser.png'
import _imports_2 from './../../public/icons/Clear Button.png'
import _imports_3 from './../../public/icons/Save Button.png'
import _imports_4 from './../../public/icons/upload Button.png'


const _withScopeId = n => (_pushScopeId("data-v-a515e020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "titleimg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Icon" }, null, -1))
const _hoisted_4 = { class: "home-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "home" }, null, -1))
const _hoisted_6 = { class: "container" }
const _hoisted_7 = {
  class: "drawing-board",
  id: "drawing-board"
}
const _hoisted_8 = {
  ref: "canvas",
  style: {"transform":"translateY(3.5px)"},
  id: "canvas"
}
const _hoisted_9 = { class: "tools-board my-8 px-3" }
const _hoisted_10 = { class: "tools-board-bottom my-8 pt-2 pb-3 px-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { for: "size-slider" }, "筆刷大小", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("canvas", _hoisted_8, null, 512)
        ]),
        _createElementVNode("section", _hoisted_9, [
          _createVNode(_component_v_row, {
            class: "py-3",
            style: {"transform":"translateY(-0.5vh)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    density: "compact",
                    icon: "mdi-brush",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTool = 'brush'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        style: _normalizeStyle({'filter': _ctx.selectedTool == 'brush' ? 'invert() brightness(50%) sepia(100) saturate(100) hue-rotate(-120deg)' : ''}),
                        src: _imports_0,
                        width: "35"
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    density: "compact",
                    icon: "mdi-eraser",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTool = 'eraser'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        style: _normalizeStyle({'filter': _ctx.selectedTool == 'eraser' ? 'invert() brightness(50%) sepia(100) saturate(100) hue-rotate(-120deg)' : ''}),
                        src: _imports_1,
                        width: "35"
                      }, null, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    density: "compact",
                    icon: "mdi-eyedropper-variant",
                    color: _ctx.selectedColor,
                    onClick: _ctx.start_select_color
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"width":"35px","height":"35px","background-size":"cover","background-image":"url('./icons/Color.png')"}, {'color':_ctx.selectedColor, 'filter': _ctx.filterString + ' drop-shadow(0px 0px 1.5px #222)'}]),
                        src: "./../../public/icons/Color.png",
                        width: "35"
                      }, null, 4)
                    ]),
                    _: 1
                  }, 8, ["color", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.brushWidth) = $event)),
            type: "range",
            class: "slider",
            id: "size-slider",
            min: "1",
            max: "30",
            value: "5"
          }, null, 512), [
            [_vModelText, _ctx.brushWidth]
          ]),
          _createVNode(_component_v_row, { class: "py-4 px-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    density: "compact",
                    variant: "text",
                    onClick: _ctx.clear_button_click
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_2,
                        cover: "",
                        width: "60"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    density: "compact",
                    variant: "text",
                    onClick: _ctx.save_button_click
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_3,
                        cover: "",
                        width: "60"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    density: "compact",
                    variant: "text",
                    onClick: _ctx.load_button_click
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_4,
                        cover: "",
                        width: "60"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.debugText), 1)
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      width: "auto",
      transition: "dialog-top-transition",
      modelValue: _ctx.selectColorPopup,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectColorPopup) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(" 選擇顏色 ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_color_picker, {
                  mode: "rgb",
                  modelValue: _ctx.previewColor,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.previewColor) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "success",
                  onClick: _ctx.confirm_select_color
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("選擇")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  color: "error",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectColorPopup = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}